(() => {
  // src/dropdown.ts
  (() => {
    if (window.__dropdownReady) return;
    window.__dropdownReady = true;
    const isOpen = (trigger) => trigger.getAttribute("aria-expanded") === "true";
    const closeDropdown = (trigger) => {
      var _a, _b;
      trigger.setAttribute("aria-expanded", "false");
      (_b = (_a = trigger.closest("dropdown-component")) == null ? void 0 : _a.querySelector(".dropdown__menu")) == null ? void 0 : _b.setAttribute("hidden", "");
    };
    const openDropdown = (trigger) => {
      var _a;
      document.querySelectorAll('.dropdown__trigger[aria-expanded="true"]').forEach((t) => {
        if (t !== trigger) closeDropdown(t);
      });
      trigger.setAttribute("aria-expanded", "true");
      const menu = (_a = trigger.closest("dropdown-component")) == null ? void 0 : _a.querySelector(".dropdown__menu");
      if (!menu) return;
      menu.removeAttribute("hidden");
      const selected = menu.querySelector(".dropdown__option--selected") || menu.querySelector(".dropdown__option");
      selected == null ? void 0 : selected.focus();
    };
    const selectOption = (option) => {
      const dropdown = option.closest("dropdown-component");
      if (!dropdown) return;
      const trigger = dropdown.querySelector(".dropdown__trigger");
      const value = option.dataset.value;
      dropdown.querySelector(".dropdown__value").textContent = option.textContent.trim();
      dropdown.querySelector('input[type="hidden"]').value = value;
      dropdown.querySelectorAll(".dropdown__option").forEach((o) => {
        o.classList.toggle("dropdown__option--selected", o === option);
        o.setAttribute("aria-selected", o === option ? "true" : "false");
      });
      closeDropdown(trigger);
      trigger.focus();
      dropdown.dispatchEvent(
        new CustomEvent("dropdown:change", { bubbles: true, detail: { value } })
      );
    };
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(".dropdown__trigger");
      if (trigger) {
        isOpen(trigger) ? closeDropdown(trigger) : openDropdown(trigger);
        return;
      }
      const option = e.target.closest(".dropdown__option");
      if (option) {
        selectOption(option);
        return;
      }
      document.querySelectorAll('.dropdown__trigger[aria-expanded="true"]').forEach((t) => {
        var _a;
        if (!((_a = t.closest("dropdown-component")) == null ? void 0 : _a.contains(e.target)))
          closeDropdown(t);
      });
    });
    document.addEventListener("keydown", (e) => {
      var _a, _b, _c, _d;
      const menu = e.target.closest(".dropdown__menu");
      if (!menu) return;
      const options = [
        ...menu.querySelectorAll(".dropdown__option")
      ];
      const idx = options.indexOf(document.activeElement);
      if (e.key === "ArrowDown") {
        e.preventDefault();
        (_a = options[(idx + 1) % options.length]) == null ? void 0 : _a.focus();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        (_b = options[(idx - 1 + options.length) % options.length]) == null ? void 0 : _b.focus();
      } else if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        (_c = document.activeElement) == null ? void 0 : _c.click();
      } else if (e.key === "Escape") {
        const trigger = (_d = menu.closest("dropdown-component")) == null ? void 0 : _d.querySelector(".dropdown__trigger");
        if (trigger) {
          closeDropdown(trigger);
          trigger.focus();
        }
      }
    });
  })();
})();
